import { IncidentOrigin } from '@/features/incidents-table'
import {
  DeviceType,
  IncidentPriority,
  IncidentSource,
  IncidentStatus,
} from '@/graphql/generated/schemas'

import { formatFullName } from './formats'

export const getIncidentStatusColor = (status: IncidentStatus) => {
  switch (status) {
    case IncidentStatus.Resolved:
      return 'incident.resolved.100'
    case IncidentStatus.Active:
      return 'incident.active.100'
    case IncidentStatus.InProgress:
      return 'incident.progress.100'
    default:
      return '#888888'
  }
}

export const getIncidentStatusColorHex = (status: IncidentStatus) => {
  switch (status) {
    case IncidentStatus.Resolved:
      return '#29D11E'
    case IncidentStatus.Active:
      return '#D01030'
    case IncidentStatus.InProgress:
      return '#D16A1E'
    default:
      return '#888888'
  }
}

export const getIncidentStatusDisplayName = (
  status: IncidentStatus,
  isFlagged?: boolean
) => {
  if (isFlagged) {
    return 'Flagged'
  }
  switch (status) {
    case IncidentStatus.Resolved:
      return 'Resolved'
    case IncidentStatus.Active:
      return 'Active'
    case IncidentStatus.InProgress:
      return 'In Progress'
    default:
      return 'Unknown'
  }
}
export const getIncidentSourceDisplayName = (source: IncidentOrigin) => {
  switch (source.type) {
    case DeviceType.Alarm:
      return source.name
    case DeviceType.Camera:
      return source.name
    case DeviceType.Door:
      return source.name
    case IncidentSource.QuickReport:
      return 'QuickReport'
    case IncidentSource.Guard:
      return 'Guard'
    default:
      return 'Manual'
  }
}

export const isAIOperator = (obj: {
  firstName?: string
  lastName?: string
}): boolean => {
  return formatFullName(obj) === 'AI Operator'
}

export const getIncidentPriorityColor = (
  priority?: IncidentPriority | null
) => {
  switch (priority) {
    case IncidentPriority.Critical:
      return '#F16974'
    case IncidentPriority.High:
      return '#fae8eb'
    case IncidentPriority.Medium:
      return '#FFF0E5'
    case IncidentPriority.Low:
      return '#e8fae9'
    default:
      return 'gray.100'
  }
}

export const getIncidentPriorityDisplayName = (
  priority?: IncidentPriority | null
) => {
  switch (priority) {
    case IncidentPriority.Critical:
      return 'Critical'
    case IncidentPriority.High:
      return 'High'
    case IncidentPriority.Medium:
      return 'Medium'
    case IncidentPriority.Low:
      return 'Low'
    default:
      return 'No Priority'
  }
}
